import type { VenueAddress } from '../../../../api/workshops';

/** The address as two display lines: street (with suite), then city, state and zip. */
export function venueAddressLines(address: VenueAddress): [string, string] {
  const street = [address.addressLine1, address.addressLine2].filter(Boolean).join(', ');
  return [street, `${address.city}, ${address.state} ${address.zipCode}`];
}

/**
 * A Google Maps driving-directions link to the address. On a phone it opens
 * the Maps app; anywhere else it opens Maps in the browser.
 */
export function directionsUrlFor(address: VenueAddress): string {
  const destination = venueAddressLines(address).join(', ');
  const params = new URLSearchParams({ api: '1', destination, travelmode: 'driving' });
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}
